var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4741 0C35.7202 2.78233 34.9717 5.55952 34.2178 8.34185C25.6634 15.1974 17.1089 22.0581 8.55446 28.9136L39.0297 39.7138L19.7822 55.1426L22.9901 47.4282C25.1287 45.5408 27.2673 43.6584 29.4059 41.771C19.6057 38.1709 9.8002 34.5709 0 30.9708C12.158 20.6489 24.316 10.3219 36.4741 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5259 68C18.2798 65.2177 19.0283 62.4405 19.7822 59.6581C28.3366 52.8026 36.8911 45.9419 45.4455 39.0864C35.2871 35.4863 25.1287 31.8862 14.9703 28.2862C21.3861 23.1432 27.802 18.0003 34.2178 12.8574L31.0099 20.5718C28.8713 22.4592 26.7327 24.3416 24.5941 26.229C34.3943 29.8291 44.1998 33.4291 54 37.0292C41.842 47.3511 29.684 57.6781 17.5259 68Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.a1353e485ccbdbc206d6524284f907e1.svg";
export { ForwardRef as ReactComponent };